/**
 * mi-comunidad
 * Version 2.0 de la comunidad
 *
 * The version of the OpenAPI document: 2.54.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface AssessmentManagementControllerChangeAssessmentStatusRequest { 
    /**
     * Nuevo estado del assessment
     */
    status: AssessmentManagementControllerChangeAssessmentStatusRequest.StatusEnum;
    modifiedBy?: number;
}
export namespace AssessmentManagementControllerChangeAssessmentStatusRequest {
    export type StatusEnum = 'active' | 'paused' | 'completed' | 'archived';
    export const StatusEnum = {
        Active: 'active' as StatusEnum,
        Paused: 'paused' as StatusEnum,
        Completed: 'completed' as StatusEnum,
        Archived: 'archived' as StatusEnum
    };
}


